import { useT } from "../lib/i18n";

export const Marquee = () => {
  const { t } = useT();
  const words = t("marquee");
  const row = [...words, ...words];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 py-6 bg-[#06101F]">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {row.map((w, i) => (
          <span key={i} className="font-display text-5xl sm:text-7xl px-6 flex items-center gap-6">
            <span className={i % 2 ? "text-stroke" : ""}>{w}</span>
            <span className="text-[#1FD1FF] text-3xl">✶</span>
          </span>
        ))}
      </div>
    </div>
  );
};
